/* 
Order 1: Retorna data começando pelo ano
Order 2: Retorna data começando pelo dia
Order 3: Retorna hora, minutos e segundos
*/

function TimeConverter(timestamp, order) {
  if (!timestamp) return;

  if (order === 1 || order === 2) {
    var aux = new Date(timestamp);
    var year = aux.getFullYear();
    var month = aux.getMonth() + 1;
    var date = aux.getDate();

    if (parseInt(month) < 10) month = "0" + month;

    if (parseInt(date) < 10) date = "0" + date;
  }

  var time = "";

  if (order === 1 || !order) time = year + "-" + month + "-" + date;

  if (order === 2) time = date + "-" + month + "-" + year;

  if (order === 3) {
    let date = new Date(timestamp);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    time =
      ("0" + hours).slice(-2) +
      ":" +
      ("0" + minutes).slice(-2) +
      ":" +
      ("0" + seconds).slice(-2);
  }

  return time;
}

export default TimeConverter;
